/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Override_Judge_CommentInputs */



/**
* | output |
* | --- |
* | "Judge comment (required)" |
*
* @param {Override_Judge_CommentInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const override_judge_comment = /** @type {((inputs?: Override_Judge_CommentInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Override_Judge_CommentInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commentaire de l'arbitre (requis)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comentario del juez (obligatorio)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Comentário do juiz (obrigatório)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Commento del giudice (obbligatorio)")
	return /** @type {LocalizedString} */ ("Judge comment (required)")
});